import { useMemo } from "react";
import S from "./useIconColor.module.scss";

export const useIconColor = (iconColor: string) => {
    const iconColorClassName = useMemo(() => {
        switch (iconColor) {
            case "SECONDARY_ICON_COLOR":
                return S.iconColorSecondary;
        }
    }, [iconColor]);

    return { iconColorClassName };
};
